import * as actionTypes from '../actions/actionTypes';


const INITIAL_STATE = {
    loading: true,
    profileObjects: {
        screenMode: "profile_user",
        showProfile: false,
    }
}

const AuthReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.PROFILE_UPDATE_PROFILEOBJECTS:
            return {
                loading: true
            }
        case actionTypes.PROFILE_UPDATE_PROFILEOBJECTS_SUCCESS:
            return {
                loading: false,
                profileObjects: { ...state.profileObjects, ...action.payload }
            }
        case actionTypes.PROFILE_SET_INITIAL_STATE:
            let initObj = { ...INITIAL_STATE.profileObjects, user: state.profileObjects.user, ...action.payload }
            return {
                loading: false,
                profileObjects: initObj
            }
        default:
            return state;
    }
}

export default AuthReducer;